import { h, Fragment } from 'preact';
import { useEffect, useMemo, useState } from 'preact/hooks';
import MobileSubMenuItems from './mobile-submenu-items';
import MobileSubMenuTabs from './mobile-submenu-tabs';

const MobileSubmenu = ({
  megaMenus,
  megaMenusBanners,
  submenuContent,
  activeSubMenuLink,
}) => {
  const isTabsMenus = submenuContent
    ? !!submenuContent?.find((m) => m.submenus.length > 0)
    : false;
  const [activeTab, setActiveTab] = useState(0);
  const [activeMenu, setActiveMenu] = useState(
    submenuContent[activeTab]?.submenus,
  );

  useEffect(() => {
    setActiveMenu(submenuContent[activeTab]?.submenus);
  }, [submenuContent, activeTab]);

  const tabMenus = useMemo(
    () => (
      <>
        <MobileSubMenuTabs
          menu={submenuContent}
          megaMenus={megaMenus}
          megaMenusBanners={megaMenusBanners}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
        />
      </>
    ),
    [activeMenu, activeTab, submenuContent, megaMenus, megaMenusBanners],
  );

  const menus = useMemo(
    () => (
        <>      
        <MobileSubMenuItems
      megaMenus={megaMenus}
      megaMenusBanners={megaMenusBanners}
        activeSubMenuLink={activeSubMenuLink}
      />
      </>

    ),
    [activeSubMenuLink, megaMenus, megaMenusBanners],
  );

  return (
    <>
      {!isTabsMenus && menus}
      {isTabsMenus && tabMenus}
    </>
  );
};

export default MobileSubmenu;
